import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';

import asModal from '../../../../components/as-modal';
import messages from './messages';
import style from './style.module.less';
import { closeImportSummaryModal } from '../../../../store/inventory/inventory.actions';

const ImportTitle = <FormattedMessage {...messages.importModalSummaryTitle} />;
const ImportMessage = <FormattedMessage {...messages.importModalSummaryMessage} />;
const ConfirmButton = <FormattedMessage {...messages.confirm} />;

const ImportFormModal = () => {
  const dispatch = useDispatch();
  const importSummary = useSelector((state) => state.inventory.importSummary);
  const onClose = useCallback(() => {
    dispatch(closeImportSummaryModal());
  }, [dispatch]);
  return (
    <Modal className={style['confirmation-modal']} size='medium'>
      <ModalHeader closeModal={onClose}>{ImportTitle}</ModalHeader>
      <ModalBody className={style['confirmation-modal-body']}>
        <p>
          <b>{ImportMessage}</b>
        </p>
        <br />
        {importSummary.map((statement, index) => (
          <p key={`importSummaryStatement${index}`}>{statement}</p>
        ))}
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose} theme='primary'>
          {ConfirmButton}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default asModal(ImportFormModal);
